var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff2F(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 62.59 182.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f3b792;}.cls-3{fill:#1299a1;}.cls-4{fill:#232323;}.cls-5{fill:#004568;}.cls-6{fill:#0d5278;}.cls-7{fill:#12adb2;}.cls-8{fill:#50290a;}.cls-9{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-0.35 0.16)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 62.57,
    height: 182.59
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Staff_Male_04b",
    "data-name": "Staff Male 04b",
    viewBox: "0 0 62.59 182.57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.89,102.34,55.2,98,59,96.66s4.54-5.4,3.47-6c-.91-.47-4.12,2.12-4.12,2.12s4.61-6.17,3.93-6.9c-2.15-2.33-5.93.26-6.87,1.42-1.27,1.59-2.37,2.37-3.86,5.44-1.75,3.6-3.79,8.09-3.89,8.34-.17.49-1.6,3.35-1.6,3.35l5.78,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.55,152.67c5.58.57,7.87-3.54,8.92-9.1s1.28-22.45,1.28-22.45l6.76-21.84c0-.51-6.31-3.33-6.31-3.33C46,99.3,39.84,113.63,39,116.68c-.66,2.41-3.25,19.48-3.6,24.7S33.65,152.16,38.55,152.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.89,26.11c0-2.35-.7-5.39,0-6.23s5.78-1.35,8.23-2.86,1.76-3,6.48-3.54c5.78-.67,8.75,1.69,4,4.55-5,3-6.3,3.7-9.45,8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M45.2,102.08c.35-8.25-1.93-35.88-2.28-45.65s-.7-25.77-.35-29.47-11-6.07-11.38-.51.7,22.74.53,32.51-2.45,41.1-2.45,41.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M13.11,16.57c.17-4.55-1.93-9.43-.18-12.8s5.78-4,8.4-3.71,3,4,2.1,6.91S21,14,20.43,16.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.68,99.78c-.87-10.61-1.18-39.46-2.45-47.84-1.57-10.44-1.75-29.81-1.4-34.19s11.9-6.07,11.73-.84S23.78,38.3,24.83,48.4s8.58,30.83,10.33,38.41c1.3,5.61.53,14,.53,14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M27.69,155.57c11.33,2.38,15.76-4.75,16.63-10s1.23-40.42,1.4-44-10-3.87-14.35-4.21-15-2.86-15.58,2.7S13,133.47,13,139.87,13.52,152.5,27.69,155.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.22,157.72c-2.63-.33-6.65-2.52-7.53-4.21s8.93-11.28,8.93-11.28l4.9,6.56,5.08-4c-.35,3.71-3.15,11.62-6.65,12.64S28.22,157.72,28.22,157.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.37,99.44l4-4.21s4.65-1.18,5.89-2.36S32.6,88,31.72,87s-5.6,2.19-5.6,2.19a9.51,9.51,0,0,1,1-3.37c.7-.84,5.68-3.47,3.85-4.72-2.71-1.85-7.88.84-9.63,2.36S18.54,89,17,90.51s-4.73,4.64-4.73,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.14,148.29c3.87-.26,6.48-6.91,2.8-15.67s-7.7-17.68-7.7-17.68c.71-4.11,8.23-16.63,10-18.36a15.47,15.47,0,0,1-3.5-2.19,7.59,7.59,0,0,1-2.1-3.71C6.86,97.08.39,109.89,0,112.92s4.9,20.72,6.47,25.6S11,148.63,16.14,148.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.79,155.7l1.4,4.55c-3.32,6.06-3.32,10.11-2.45,13.81s4.2,7.92,10.68,7.24,9.45-3.87,10-7.58,1.2-15.49-.9-17.35-6-2-6-2l-1-5.56a18,18,0,0,0-7,2.53A19.44,19.44,0,0,0,22.79,155.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M24.19,160.25c-2.36,1.68-4.37,5.3-4.55,10.44s3.15,12,11.47,11.88,12.08-4.21,12.78-8-9-2.28-13.57-.68A35.61,35.61,0,0,0,29.18,169s-1.33,2.48-3.06.92c-1.31-1.18-1.49-5.81,1.4-6C27.08,162.35,24.19,160.25,24.19,160.25Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vask_Sterilisation",
    "data-name": "Vask Sterilisation"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("use", {
    width: 62.59,
    height: 182.58,
    transform: "translate(62.59 182.58) rotate(180)",
    xlinkHref: "#Staff_Male_04b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff2F);
export default __webpack_public_path__ + "static/media/staff-2-f.f1bfd8052534a443fd9f37c285314d66.svg";
export { ForwardRef as ReactComponent };